var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOfTwice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 141.1168,
    height: 157.246,
    viewBox: "0 0 141.1168 157.246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:#f69;}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 70.5584,
    cy: 64.0576,
    r: 67.3864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1363,
    stopColor: "#fc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 81.9823,
    y1: 147.1449,
    x2: 90.2882,
    y2: 149.3705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5195,
    stopColor: "#ff8c99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 113.1664,
    y1: 139.7131,
    x2: 123.0392,
    y2: 156.8132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#f5bb98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8823,
    stopColor: "#fc9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 58.4443,
    y1: 140.0737,
    x2: 79.3095,
    y2: 152.1202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7188,
    stopColor: "#ff6a99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9699"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 94.4113,
    y1: 142.0054,
    x2: 106.9887,
    y2: 154.5827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8199"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4452,
    stopColor: "#f5bb98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8823,
    stopColor: "#fc9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.7361,57.4615a14.4729,14.4729,0,0,1,1.5537-1.3589,6.3359,6.3359,0,0,1,8.3177,1.1844,7.9791,7.9791,0,0,1,1.4248,4.0084c.6963,5.2964-3.0076,9.6044-7.4418,11.6319-.6479.2963-1.3325.5148-2.0072.7489-.38.1317-.5891.2878-.5235.7687a32.405,32.405,0,0,1-.09,7.9648,73.5184,73.5184,0,0,1-5.34,20.1725,56.6463,56.6463,0,0,1-8.2139,14.1861,31.0262,31.0262,0,0,1-11.4836,9.242,23.2135,23.2135,0,0,1-13.138,1.7249,18.1394,18.1394,0,0,1-8.8734-4.3218c-1.0439-.8723-2.01-1.8381-2.9742-2.7276-1.2482.98-2.4466,2.06-3.7767,2.9407-4.6737,3.0954-9.7639,4.9016-15.4471,4.4078a21.5415,21.5415,0,0,1-9.6692-3.4184c-5.5285-3.4928-8.5362-8.7052-10.0038-14.9426a51.1608,51.1608,0,0,1-.79-15.7323A116.8615,116.8615,0,0,1,44.14,75.8794c1.6348-6.9085,3.466-13.7712,5.2605-20.6411,1.1906-4.5581,2.4671-9.0938,3.7012-13.6406a6.132,6.132,0,0,0,.0958-.647c-1.0081-.0815-1.9751-.1919-2.945-.2324a61.6288,61.6288,0,0,0-10.4815.3727c-5.4542.704-10.7163,2.0064-15.4869,4.8872a25.744,25.744,0,0,0-7.93,8.1c-2.8069,4.1961-3.6293,8.89-3.4147,13.8386.3633,8.3786,6.1268,14.1531,13.4877,16.0721.6869.1792,1.4027.2478,2.2154.3865a4.61,4.61,0,0,1-.4124.4656q-5.8066,4.8289-11.6216,9.648c-1.0157.84-2.0789,1.6233-3.0842,2.4753a1.7845,1.7845,0,0,1-1.8024.3495c-5.5481-1.6227-8.9875-5.322-10.69-10.7722C-.4264,81.8721-.1553,77.18.7138,72.46A53.5436,53.5436,0,0,1,8.8569,52.28,66.94,66.94,0,0,1,20.4486,39.2639,82.87,82.87,0,0,1,38.4018,27.2972,60.88,60.88,0,0,1,55.2949,21.613c4.7632-.8228,9.5692-1.4,14.3591-2.0657,5.1957-.7219,10.398-1.397,15.5914-2.1346a136.9951,136.9951,0,0,0,16.34-3.2471,51.7247,51.7247,0,0,0,15.1546-6.38A31.4776,31.4776,0,0,0,124.25.9332c.2063-.261.4367-.503.8127-.9332,0,1.02-.0072,1.8384.0012,2.6564a61.7171,61.7171,0,0,1-1.3149,14.3566c-1.5027,6.6257-4.3936,12.486-9.5458,17.0639A30.7462,30.7462,0,0,1,102.47,40.4022a42.2724,42.2724,0,0,1-9.8022,1.7963c-3.059.1789-6.1323.1472-9.1992.1442-1.5071-.0015-3.0135-.1763-4.5214-.2026a1.0656,1.0656,0,0,0-.7845.5293Q74.87,49.7367,71.6405,56.833c-3.09,6.7806-5.9346,13.66-8.3536,20.7132a99.7777,99.7777,0,0,0-3.9278,14.6145,41.1133,41.1133,0,0,0-.5538,14.2969,15.37,15.37,0,0,0,5.1881,9.66,8.4549,8.4549,0,0,0,12.2074-.901.8549.8549,0,0,0,.047-1.19,40.718,40.718,0,0,1-4.4455-11.01c-1.3993-5.8419-1.7068-11.7035.0674-17.5332A19.22,19.22,0,0,1,78.9644,75.03a14.1737,14.1737,0,0,1,9.8748-2.8521c5.7365.605,9.8713,3.3887,11.6443,9.4772a22.5559,22.5559,0,0,1-.7557,14.09c-2.2137,6.3475-5.9759,11.75-10.3433,16.7741-.3459.398-.6809.81-1.0628,1.171-.3186.3014-.3011.5075-.0182.8323a7.3631,7.3631,0,0,0,4.242,2.2178c3.3158.7212,6.2606-.3255,9.0592-1.9191,4.0536-2.3081,6.7843-5.8537,8.9469-9.8874a36.8432,36.8432,0,0,0,3.6333-9.9433,39.9663,39.9663,0,0,0-.9842-21.2725,18.8814,18.8814,0,0,0-3.5469-6.1219,23.7677,23.7677,0,0,1-2.2709-3.0467,3.9483,3.9483,0,0,1,.1171-4.4833c2.5417-3.71,5.9158-5.9888,10.5816-5.7821a8.3556,8.3556,0,0,1,5.83,2.9314c1.3437,1.4605,2.5043,3.0879,3.79,4.6036a4.17,4.17,0,0,0,3.52,1.6314,1.9675,1.9675,0,0,0,1.8549-2.6246,4.7146,4.7146,0,0,0-2.4-2.83C130.4334,57.8557,130.1885,57.7182,129.7361,57.4615Zm-46.2775,47.07c.3046-.3628.4743-.552.63-.7522a31.5518,31.5518,0,0,0,4.2061-7.1665A17.4276,17.4276,0,0,0,89.7831,90.07c.0263-1.9069-.736-3.3179-2.0762-3.8629a3.9556,3.9556,0,0,0-4.2777,1.0482,6.38,6.38,0,0,0-1.4325,3.2463,27.8407,27.8407,0,0,0,.7364,12.0153C82.8978,103.1483,83.1736,103.75,83.4586,104.5318Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 83.9848,
    y: 139.6712,
    width: 4.3009,
    height: 17.1729
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "117.895 152.964 117.895 150.076 122.921 150.076 122.921 146.217 117.895 146.217 117.895 143.438 122.873 143.438 122.873 139.641 117.895 139.641 117.895 139.641 113.291 139.641 113.291 156.814 116.281 156.814 116.281 156.822 123.024 156.822 123.024 152.964 117.895 152.964"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "56.877 139.691 53.543 139.691 53.543 139.679 49.308 139.679 49.308 139.691 46.044 139.691 46.044 143.466 49.308 143.466 49.308 156.82 53.543 156.82 53.543 143.466 56.877 143.466 56.877 139.691"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.9343,139.5975c-.513,2.083-2.1553,8.8127-2.4657,10.0944-.1038-.45-2.5387-9.8571-2.5887-10.0347l-.0014-.0051h0l-.0043-.0152H68.3277s-2.4862,9.62-2.59,10.07c-.3105-1.2817-1.9527-8.0114-2.4658-10.0944-.7409.0031-3.7831.0057-4.5635.0036.1016.3838,3.1367,11.2622,4.9049,17.2243l3.8549-.012s2.4084-8.97,2.6329-9.8164c.226.8516,2.637,9.8012,2.637,9.8012l3.8549.012c1.7681-5.9621,4.8033-16.84,4.9049-17.2243C80.7174,139.6032,77.6752,139.6006,76.9343,139.5975Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.2116,146.0464l-4.6185-.0282-.209-.3543a4.5751,4.5751,0,0,0-2.9646-1.9505,4.26,4.26,0,0,0-2.1381.2081,4.582,4.582,0,0,0-3.0063,4.8062,4.6375,4.6375,0,0,0,3.54,4.0415,4.1467,4.1467,0,0,0,2.8881-.3077,5.2976,5.2976,0,0,0,1.4571-1.2775c.0963-.1255.5389-.7185.5389-.7185h0l4.464.03a8.6118,8.6118,0,0,1-8.3206,6.75A8.8582,8.8582,0,0,1,91.914,148.87a8.7855,8.7855,0,0,1,17.2976-2.8237Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOfTwice);
export default __webpack_public_path__ + "static/media/Logo_of_TWICE.47b6b29b5d8e5b230cdb58f4d96cff91.svg";
export { ForwardRef as ReactComponent };